var REQUEST_TYPE = '@widget-kit/rpc/request';
var RESPONSE_TYPE = '@widget-kit/rpc/response';
function createRequest(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return {
        method: method,
        args: args,
        type: REQUEST_TYPE,
        sequenceId: 0,
    };
}
function createResponse(request, payload, error) {
    return {
        payload: payload,
        error: error,
        type: RESPONSE_TYPE,
        sequenceId: request.sequenceId,
    };
}
function createConnection(currentWindow, targetWindow, targetOrigin) {
    if (targetOrigin === void 0) { targetOrigin = '*'; }
    var postMessage = function (message) { return targetWindow.postMessage(message, targetOrigin); };
    var requestHandlers = {};
    function handleRequest(request) {
        var handler = requestHandlers[request.method];
        if (typeof handler !== 'function') {
            // TODO: log warning in dev mode or maybe in debug mode?
            return;
        }
        var responseProducer = function (payload, error) {
            postMessage(createResponse(request, payload, error));
        };
        handler.apply(void 0, [responseProducer].concat(request.args));
    }
    var responseHandlers = {};
    function handleResponse(response) {
        var handler = responseHandlers[response.sequenceId];
        if (typeof handler !== 'function') {
            return;
        }
        handler(response);
        delete requestHandlers[response.sequenceId];
    }
    currentWindow.addEventListener('message', function (event) {
        if (!isEventTrusted(event, targetWindow, targetOrigin)) {
            return;
        }
        var message = checkMessage(event.data);
        if (!message) {
            return;
        }
        switch (message.type) {
            case REQUEST_TYPE:
                return handleRequest(message);
            case RESPONSE_TYPE:
                return handleResponse(message);
        }
    });
    var nextSequenceId = createSequenceIdGenerator();
    return {
        handle: function (method, handler) {
            if (typeof requestHandlers[method] === 'function') {
                throw new Error("Handler for " + method + " already declared");
            }
            requestHandlers[method] = handler;
        },
        send: function (request, onResponse) {
            // TODO: Should throw on invalid requests
            request.sequenceId = nextSequenceId();
            if (onResponse) {
                responseHandlers[request.sequenceId] = onResponse;
            }
            postMessage(request);
        },
    };
}
function createSequenceIdGenerator() {
    var sequenceId = 0;
    return function () {
        sequenceId += 1;
        return sequenceId;
    };
}
function isEventTrusted(event, expectedWindow, expectedOrigin) {
    return (event.source === expectedWindow && (expectedOrigin === '*' || event.origin === expectedOrigin));
}
function checkMessage(message) {
    if (message && typeof message.sequenceId === 'number' && typeof message.type === 'string') {
        return message;
    }
    return null;
}

function createConnection$1(targetWindow, targetOrigin) {
    if (targetOrigin === void 0) { targetOrigin = '*'; }
    return createConnection(window, targetWindow, targetOrigin);
}

export { createConnection$1 as createConnection, createRequest };
//# sourceMappingURL=index.esm.js.map
